import React, { useState, useEffect, useRef } from "react";
import { Chart, ChartWrapperOptions } from "react-google-charts";
import { Loader } from "../../atoms/loader";

interface ComboChartProps {
  data: any;
  options: ChartWrapperOptions["options"];
  isLoading?: boolean;
  isFetching?: boolean;
  style?: React.CSSProperties;
}

export const ComboChart = ({
  data,
  options,
  isLoading,
  isFetching = false,
  style,
}: ComboChartProps) => {
  const [chartSize, setChartSize] = useState({ width: 0, height: 0 });
  const [chartKey, setChartKey] = useState(0);
  const chartContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const chartContainer = chartContainerRef.current;

    const resizeObserver = new ResizeObserver(() => {
      if (chartContainer) {
        setChartSize({
          width: chartContainer.offsetWidth,
          height: chartContainer.offsetHeight,
        });
        setChartKey((prevKey) => prevKey + 1); // Update the chart key to force re-render
      }
    });

    if (chartContainer) {
      resizeObserver.observe(chartContainer);
    }

    // Clean up observer on component unmount
    return () => {
      if (chartContainer) {
        resizeObserver.unobserve(chartContainer);
      }
    };
  }, []);

  return (
    <div ref={chartContainerRef} className="m-chart__container">
      {isLoading ? (
        <div className="m-chart__skelton"></div>
      ) : (
        data.length ? (
          <Loader isLoading={isFetching} className="m-chart__loader">
            <Chart
              key={chartKey}
              chartType="ComboChart"
              width={chartSize.width}
              height={chartSize.height}
              style={style}
              data={data}
              options={options}
            />
          </Loader>
        ) : (
          <p className="m-chart__nodata">No Data Found</p>
        )
      )}
    </div>
  );
};
